<template>
  <div>
    <div>NewsFeed</div>
    <div class="feed-container">
      <ul>
      <div v-for="item of news" :key="item.data.name">
        <li>
          <a v-bind:href="item.data.url" target="_blank">{{item.data.title}}</a>
        </li>
      </div>
      </ul>
      <div class="pagination">
        <div class="pag-elem-prev">
          <a href="#" v-if="pagination.pages.length > 1" v-on:click="prevNews()">
            PREV
          </a>
        </div>
        <div class="pag-elem-next">
          <a href="#" v-if="!pagination.end" v-on:click="nextNews()">
            NEXT
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      news: [],
      pagination: {
        current: 0,
        pages: [null],
        start: true,
        end: false
      }
    }
  },
  methods: {
    prevNews () {
      this.pagination.end = false

      const page = this.pagination.pages.pop()
      if (page === null) {
        this.pagination.start = true
      } else {
        this.pagination.start = false
      }

      const url = `https://www.reddit.com/r/FloridaMan.json?count=20&after=${page}&stickied=false`

      this.$http.get(url)
        .then(response => {
          this.news = response.data.data.children.slice(2)
          this.pagination.current--
        })
    },
    nextNews () {
      const page = this.pagination.pages[this.pagination.current]
      if (page === null) {
        if (this.pagination.current === 0) {
          this.pagination.start = true
        } else {
          this.pagination.start = false
        }
      } else {
        this.pagination.start = false
        this.pagination.end = false
      }
      const url = `https://www.reddit.com/r/FloridaMan.json?count=20&after=${page}&stickied=false`
      this.$http.get(url)
        .then(response => {
          if (response.data.data.after === null) {
            this.pagination.end = true
          } else {
            this.pagination.end = false
          }
          this.pagination.pages.push(response.data.data.after)
          this.pagination.current++
          this.news = response.data.data.children.slice(2)
        })
    }
  },
  beforeMount () {
    this.$store.commit('setActualRoute', this.$route.name)
  },
  mounted () {
    this.$store.commit('setBannerTitle', 'NewsFeed')
    const url = 'https://www.reddit.com/r/FloridaMan.json?count=20'
    this.$http.get(url)
      .then(response => {
        this.news = response.data.data.children.slice(2)
      })
  }
}
</script>

<style scoped>
  .feed-container {
    font-family: "ModeSeven";
    font-size: 1.25em;
    padding-right: 20px;
  }

  .pagination {
    margin: 20px 20px 40px 20px;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
  }

  .pag-elem-prev {
    width: 50%;
    padding-left: 10px;
  }

  .pag-elem-next {
    width: 50%;
    text-align: right;
    padding-right: 10px;
  }

</style>
